import useSessionRenewal from './useSessionRenewal';

const SessionRenewal = () => {
  useSessionRenewal();
  return null;
};

export default SessionRenewal;
